/**
 * TODO: The functionality in this file duplicates the functionality in
 * product-option-form-summary.js. This component should be updated to somehow
 * reuse the functionality provided by product-option-form.
 */
(function (window, document) {
  window.componentEvents.on('consumer-rx-form-instantiate', init);

  /**
   * Instantiate consumer-rx summary section.
   */
  function init(form) {
    const steps = form.querySelectorAll('[data-rx-step]');
    const summary = form.querySelector('[data-rx-price-summary]');
    const summaryContainer = form.querySelector('.consumer-rx-form__summary');
    const currencySeparator = summary.dataset.rxCurrencySeparator;
    const currencySuffix = summary.dataset.rxCurrencySuffix === 'true';
    let currencySymbolPrefix, currencySymbolSuffix;
    if (currencySuffix) {
      currencySymbolPrefix = '';
      // Currencies that place the symbol _after_ the amount separate it with a
      // space, e.g. "199.95 $".
      currencySymbolSuffix = ` ${summary.dataset.rxCurrencySymbol}`;
    } else {
      currencySymbolPrefix = summary.dataset.rxCurrencySymbol;
      currencySymbolSuffix = '';
    }
    const currencyThousandIndicator = summary.dataset.rxCurrencyThousandIndicator || '';
    const summaryOptsList = createOptionsList();

    form.addEventListener('change', function (event) {
      // If target has no cost nor base price associated with it, do nothing.
      if (!event.target.dataset.rxOptionCost &&
        !event.target.dataset.rxOptionBasePrice &&
        event.target.dataset.rxSkipConfiguration !== 'true') return;
      updateSummary();
    });
    // Update summary on init.
    updateSummary();
    // Update active step padding on nav and modal open.
    window.componentEvents.on(`rx-form-nav-${form.id}`, updateActiveStepPadding);
    window.componentEvents.on('modal-change', (data) => {
      if (data.id && data.id.match('consumer-rx-modal') && data.action === 'open') {
        updateActiveStepPadding();
      }
    });
    window.componentEvents.on(`rx-form-reset-${form.id}`, updateSummary);

    /**
     * Create and insert empty list into which selected options are to be
     * injected on user selections.
     */
    function createOptionsList() {
      const list = document.createElement('UL');
      list.classList.add('price-list__options');
      summary.insertBefore(list, summary.lastElementChild);
      return list;
    }

    /**
     * Update the summary section on option selection.
     */
    function updateSummary() {
      updateSummaryItems();
      updateBasePrice();
      calculateSubtotal();
      updateActiveStepPadding();
    }

    /**
     * Update summary items according to selected options.
     */
    function updateSummaryItems() {
      const selectedOptions = Array.from(form.querySelectorAll('[data-rx-option-cost]:checked'));
      const items = selectedOptions.map(createNewOption);
      summaryOptsList.innerHTML = '';
      items.forEach((item) => summaryOptsList.appendChild(item));
    }

    /**
     * Create new list item from a selected option.
     */
    function createNewOption(option) {
      const item = document.createElement('LI');
      item.classList.add('price-item');
      const title = document.createElement('SPAN');
      title.classList.add('price-item__title');
      title.innerText = option.dataset.rxOptionLabel;
      const cost = document.createElement('SPAN');
      cost.classList.add('price-item__cost');
      const integer = option.dataset.rxOptionCost;
      const decimal = document.createElement('SPAN');
      decimal.classList.add('price-item__decimal');
      decimal.innerText = `${currencySeparator}00`;
      cost.innerText = `${currencySymbolPrefix}${formatLargeNumber(integer, currencyThousandIndicator)}`;
      cost.appendChild(decimal);
      if (currencySymbolSuffix) {
        cost.appendChild(document.createTextNode(currencySymbolSuffix));
      }
      item.appendChild(title);
      item.appendChild(cost);
      item.dataset.rxSummaryOptionCost = integer;
      return item;
    }

    /**
     * Change base price if an option is selected that updates it.
     */
    function updateBasePrice() {
      const base = summary.querySelector('[data-rx-summary-base-price]');
      // Note: this selector matches the first element that matches this
      // selector. If there are more than one option selected that updates the
      // base price, this will only match the first one. However, that should
      // never be the case, as it makes no sense for two not mutually exclusive
      // options to change the base price.
      const item = form.querySelector('[data-rx-option-base-price]:checked');
      if (item) {
        useUpdatedBasePrice(base, item);
      } else {
        restoreOriginalBasePrice(base);
      }
    }

    /**
     * Update the base price to use a special price as indicated in a form item’s
     * data-rx-option-base-price attribute.
     */
    function useUpdatedBasePrice(base, item) {
      const updatedPrice = item.dataset.rxOptionBasePrice;
      base.dataset.rxSummaryBasePriceOriginal = base.dataset.rxSummaryBasePrice;
      base.dataset.rxSummaryBasePrice = updatedPrice;
      updateBaseDisplay(base);
    }

    /**
     * Restore the base price to its original.
     */
    function restoreOriginalBasePrice(base) {
      // If no original price is stored, do nothing.
      if (!base.dataset.rxSummaryBasePriceOriginal) return;

      base.dataset.rxSummaryBasePrice = base.dataset.rxSummaryBasePriceOriginal;
      delete base.dataset.rxSummaryBasePriceOriginal;
      updateBaseDisplay(base);
    }

    /**
     * Update the base price display according to its data-rx-summary-base-price
     * attribute.
     */
    function updateBaseDisplay(base) {
      const parts = base.dataset.rxSummaryBasePrice.split(currencySeparator);
      const integer = base.querySelector('.price-item__integer');
      const decimal = base.querySelector('.price-item__decimal');
      integer.innerText = `${currencySymbolPrefix}${formatLargeNumber(parts[0], currencyThousandIndicator)}`;
      // If there is a decimal part, use it. Otherwise, use “00”.
      decimal.innerText = `${currencySeparator}${parts[1] || '00'}`;
    }

    /**
     * Calculate subtotal with the base price and the cost of each option.
     */
    function calculateSubtotal() {
      const base = summary.querySelector('[data-rx-summary-base-price]');
      const options = summaryOptsList.childNodes;
      const subtotal = summary.querySelector('[data-rx-summary-subtotal-price]');
      const decimalWrapper = document.createElement('SPAN');
      decimalWrapper.classList.add('price-item__decimal');
      // Prices may be expressed with a period or a comma as a separator.
      let cost = parseFloat(base.dataset.rxSummaryBasePrice.replace(',', '.'));
      options.forEach((option) => {
        // Prices may be expressed with a period or a comma as a separator.
        cost = cost + parseFloat(option.dataset.rxSummaryOptionCost.replace(',', '.'));
      });
      cost = cost.toFixed(2);
      const [ integer, decimal ] = cost.split('.');
      subtotal.innerText = `${currencySymbolPrefix}${formatLargeNumber(integer, currencyThousandIndicator)}`;
      decimalWrapper.innerText = `${currencySeparator}${decimal}`;
      subtotal.appendChild(decimalWrapper);
      if (currencySymbolSuffix) {
        subtotal.appendChild(document.createTextNode(currencySymbolSuffix));
      }
    }

    /**
     * Update the active step’s bottom padding to accommodate the fixed summary
     * and reset bottom padding for all other steps.
     */
    function updateActiveStepPadding() {
      const height = summaryContainer.offsetHeight;
      steps.forEach((step) => {
        if (step.dataset.rxStep === form.dataset.rxActiveStep) {
          step.style.paddingBottom = `${height}px`;
        } else {
          step.style.paddingBottom = null;
        }
      });
    }
  }
})(window, document);
